import { Component, computed, Signal } from '@angular/core';
import { Button, ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { PrimeIcons } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { COLLAPSED, NavigationItem, SidebarState } from '../../constants/navigation.constants';
import { ThemeService } from '../../services/theme.service';
import { UserService } from '../../services/user.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-left-sidebar',
  imports: [ButtonModule, MenuModule, RouterLink, TooltipModule, RouterLinkActive ],
  templateUrl: './left-sidebar.component.html',
})
export class LeftSidebarComponent {
  items: Signal<NavigationItem[]>;
  transitionDirection: SidebarState;
  isAnimatingNav = false;
  state = '';
  currentPath = '';
  constructor (
    private theme: ThemeService,
    private user: UserService,
    private nav: NavigationService
  ) {
    const logoutNavItem = {
      label: '',
      items: [
        {
            label: 'Sign Out',
            title: 'Sign Out',
            icon: PrimeIcons.SIGN_OUT,
            command: () => this.user.logout(true)
        }
      ]
    };
    this.items = computed(() => this.nav.navItems().concat(logoutNavItem));
    this.transitionDirection = this.theme.sidebarState;
    this.state = this.transitionDirection === SidebarState.EXPAND ? COLLAPSED : '';
  }

  toggleNavWidth(transitionDirection: string, button: Button) {
    if (this.isAnimatingNav) return; // Prevent duplicate actions
    const buttonEl = button.el.nativeElement;
    const arrowIcon = buttonEl.querySelector('.pi');
    this.isAnimatingNav = true;
    const animationCompleteHandler = () => {
      // on transition end set the sidebar state and the toggle text
      this.theme.sidebarState = transitionDirection === SidebarState.COLLAPSE ? SidebarState.EXPAND : SidebarState.COLLAPSE;
      this.transitionDirection = this.theme.sidebarState;
      this.isAnimatingNav = false;
      // remove the listener to prevent multiple events
      arrowIcon.removeEventListener('transitionend', animationCompleteHandler);
    }
    // add the event listener
    arrowIcon.addEventListener('transitionend', animationCompleteHandler);
    // trigger the animations (menu and arrow)
    this.state = transitionDirection === SidebarState.EXPAND ? '' : COLLAPSED;
  }
  
}
